import * as React from 'react';
import {useSelector} from 'react-redux';
import {Page} from '../../components/Page';
import {albumSelector, trackSelector} from '../../store/selectors';
import {useCurrentState} from '../MachineProvider/useCurrentService';
import {useMeta} from '../MachineProvider/useMeta';
import {IOuter} from './PageContainer.types';

export const PageContainer: React.FunctionComponent<IOuter> = () => {
  const album = useSelector(albumSelector);
  const track = useSelector(trackSelector);
  const state = useCurrentState();
  const meta = useMeta();

  const hasPaymentError = state.matches('paymentError');

  return <Page album={album} track={track} route={meta.route} hasPaymentError={hasPaymentError} />;
};

PageContainer.displayName = 'PageContainer';
